<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryOutdoorProductDetailResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <b-button-group>
                                        <em-button type="search"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   customLabel="归还"
                                                   :disabled="$_notChecked"
                                                   :busy="returnLoading"
                                                   show-name
                                                   @click="returnOutdoorItem">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author Liang Gang Qiang
// Date 2022-01-05 09:01:14

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";

export default {
    name: "sithMesInventoryOutdoorProductDetailListView",
    mixins: [emCommonListMixin, emCustomVuexMixin, emTableCheckedMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    data() {
        return {
            returnLoading: false
        }
    },
    methods: {
        returnOutdoorItem() {
            if (!this.$_notChecked) {
                this.returnLoading = true;
                this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_SITHMES_INVENTORY_URL + "/sithMesInventoryOutdoorProductDetail/returnOutdoorItem?ids=" + this.checkedItems,
                    data: {}
                }).then(() => {
                    this.$message.success("操作成功");
                    this.$refs.emListFilter.doQuery();
                }).finally(() => this.returnLoading = false);
            }
        }
    }
};
</script>